import { useState } from "react"

interface CoverImageProps {
  src: string
  alt?: string
  /** Classes for the <img> itself (sizing / object-fit live here). */
  className?: string
  /** Notified once the image has finished loading (or errored). */
  onLoad?: () => void
}

/**
 * Cover photo that fades in as one piece instead of painting row-by-row.
 * The image is held at opacity-0 over the parent's placeholder background
 * until it's fully decoded, then fades in.
 */
const CoverImage = ({ src, alt = "", className = "", onLoad }: CoverImageProps) => {
  const [loaded, setLoaded] = useState(false)

  const handleDone = () => {
    setLoaded(true)
    onLoad?.()
  }

  return (
    <img
      src={src}
      alt={alt}
      draggable="false"
      loading="eager"
      onLoad={handleDone}
      onError={handleDone} // don't trap the gallery on a broken cover
      className={`${className} transition-opacity duration-700 ease-out ${
        loaded ? "opacity-100" : "opacity-0"
      }`}
    />
  )
}

export default CoverImage
